import {
  FETCH_NEGATIVE_ITEM_LIST,
  RESET_NEGATIVE_ITEM_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const negativeItemListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEGATIVE_ITEM_LIST:
      return { list: action.payload, others: action.others };
    case RESET_NEGATIVE_ITEM_LIST:
      return initialState;
    default:
      return state;
  }
};

export default negativeItemListReducer;
